import { id, event } from "@planzone/dto";
import { events } from "@planzone/events";
import { createStateReducer } from "../../utils/createStateReducer";
import {
  handleEditRequest,
  handleEditSuccess,
  handleEditFailure,
} from "./editEvent";
import {
  handleAssignTagRequest,
  handleAssignTagSuccess,
  handleAssignTagFailure,
} from "./assignTag";
import {
  handleRemoveTagFailure,
  handleRemoveTagSuccess,
  handleRemoveTagRequest,
} from "./removeTag";
import { handleMoveListElement } from "./moveListElement";

const initialState = { ...event, uuid: id };

const reduceEvent = createStateReducer(initialState, {
  [events.editEventRequested]: handleEditRequest,
  [events.editEventSucceeded]: handleEditSuccess,
  [events.editEventFailed]: handleEditFailure,
  [events.assignTagRequested]: handleAssignTagRequest,
  [events.assignTagSucceeded]: handleAssignTagSuccess,
  [events.assignTagFailed]: handleAssignTagFailure,
  [events.removeTagRequested]: handleRemoveTagRequest,
  [events.removeTagSucceeded]: handleRemoveTagSuccess,
  [events.removeTagFailed]: handleRemoveTagFailure,
  [events.moveListElementSucceeded]: handleMoveListElement,
});

export { reduceEvent };
